import { Link } from "@tanstack/react-router";
import { Phone, Mail, MapPin } from "lucide-react";

const FI_LINKS: { to: string; label: string }[] = [
  { to: "/fi", label: "Etusivu" },
  { to: "/fi/asuntoautot", label: "Asuntoautot" },
  { to: "/fi/asuntovaunut", label: "Asuntovaunut" },
  { to: "/fi/rapido", label: "Rapido" },
  { to: "/fi/tuonti", label: "Tuonti & autovero" },
  { to: "/fi/ostajan-opas", label: "Ostajan opas" },
  { to: "/fi/kosteusmittaus", label: "Kosteusmittaus" },
  { to: "/fi/yhteystiedot", label: "Yhteystiedot" },
];

/** Suomenkielinen alanavigaatio + yhteystietopalkki. */
export function FiNav() {
  return (
    <section className="container-edge -mt-6 pb-2">
      <nav aria-label="Suomenkielinen valikko" className="flex flex-wrap gap-2">
        {FI_LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            activeProps={{ className: "border-accent bg-accent/10 text-accent" }}
            className="inline-flex rounded-full border border-border bg-card px-4 py-2 text-sm font-medium transition hover:bg-secondary"
          >
            {l.label}
          </Link>
        ))}
      </nav>
      <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
        <span className="inline-flex items-center gap-2">
          <Phone size={14} className="text-accent" />
          <a href="tel:+46708629743" className="hover:text-accent">
            +46 70 862 97 43
          </a>
        </span>
        <span className="inline-flex items-center gap-2">
          <Mail size={14} className="text-accent" />
          <a href="mailto:info@akhusbilfritid.se" className="hover:text-accent">
            info@akhusbilfritid.se
          </a>
        </span>
        <span className="inline-flex items-center gap-2">
          <MapPin size={14} className="text-accent" /> Stabsvägen 5, Kalix · Torniosta 90 km
        </span>
      </div>
    </section>
  );
}

/** Kaksikielinen linkkirivi sivun loppuun. */
export function FiSwedishLink({ to, label }: { to: string; label: string }) {
  return (
    <section className="container-edge pb-16">
      <div className="rounded-3xl border border-border bg-card p-6 md:p-8">
        <p className="eyebrow">På svenska</p>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          Vill du läsa samma information på svenska?
        </p>
        <Link
          to={to}
          className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-3 text-sm font-semibold text-primary-foreground transition hover:bg-primary/90"
        >
          {label} →
        </Link>
      </div>
    </section>
  );
}

/**
 * hreflang-parit: sama sisältö suomeksi ja ruotsiksi.
 * Käytetään sekä /fi-sivuilla että niiden ruotsinkielisillä vastineilla.
 */
export function hreflangPair(fiPath: string, svPath: string) {
  const base = "https://www.akhusbilfritid.se";
  return [
    { rel: "alternate", hrefLang: "fi-FI", href: `${base}${fiPath}` },
    { rel: "alternate", hrefLang: "sv-SE", href: `${base}${svPath}` },
    { rel: "alternate", hrefLang: "x-default", href: `${base}${svPath}` },
  ];
}
